export enum LoanApplicationAction {
  UN_SIGN_CONTRACT = 'UN_SIGN_CONTRACT',
  SET_LENDER_REQUEST_ID = 'SET_LENDER_REQUEST_ID',
  CHANGE_LENDER_APPROVAL_STATUS = 'CHANGE_LENDER_APPROVAL_STATUS',
  SET_CONTRACT_SIGNED = 'SET_CONTRACT_SIGNED',
  RESEND_CONTRACT_SIGNATURE_TO_BORROWER = 'RESEND_CONTRACT_SIGNATURE_TO_BORROWER',
  SEND_CONTRACT_SIGNATURE_TO_BORROWER = 'SEND_CONTRACT_SIGNATURE_TO_BORROWER',
}
